"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIT_HASH = exports.CANDIDATE_REPORT_FEEDBACK_LINK = void 0;
const CANDIDATE_REPORT_FEEDBACK_LINK = exports.CANDIDATE_REPORT_FEEDBACK_LINK = 'https://www.surveymonkey.com/r/Y9H3QHH';
// This token is replaced by the webui build process.
const GIT_HASH = exports.GIT_HASH = '{{GIT_HASH}}';